import { useRef, useEffect } from 'react';
import Audio from '../Audio';

// meant to be used once per component for simple audio play and stop
// returns array with two functions: [playAudio, stopAudio]
export const usePlayAudio = () => {
  // audio ref for keepig track of audio across multiple renders
  const audio = useRef(null);

  // stops current audio playing
  const stopAudio = () => {
    if (audio.current) {
      audio.current.stop();
    }
  };

  // takes same arguments (including same options object) as new Audio with the exception of
  // not requiring a track name
  const playAudio = (trackSource, options = {}) => {
    stopAudio();

    if (Array.isArray(trackSource)) {
      const [currentTrack, ...remainingTracks] = trackSource;

      audio.current = new Audio(currentTrack, '', {
        ...options,
        onend: remainingTracks.length > 0 ? () => playAudio(remainingTracks, options) : options.onend,
      });
    } else {
      audio.current = new Audio(trackSource, '', options);
    }

    audio.current.play();
  };

  // useEffect returns a function to call when component unmounts: stopAudio
  useEffect(() => stopAudio, []);

  return [playAudio, stopAudio];
};

export default usePlayAudio;
